<template>
  <div class="compress-container page-container">
    <v-header></v-header>
    <div class="page-wrap">
      <div class="content">
        <div class="main">
          <div class="side-menu" style="padding:10px 0;">
            <div class="compress-image">
              <div class="compress-options">
                <div class="compress-item">
                  <span class="item-label">压缩方式</span>
                  <el-radio-group v-model="compressMode" size="small" @change="changeCompressMode">
                    <el-radio-button label="ratio">压缩质量</el-radio-button>
                    <el-radio-button label="size">内存大小</el-radio-button>
                  </el-radio-group>
                </div>
              </div>
                
              <div class="block" v-if="compressMode == 'ratio'">
                <span class="label-title">压缩质量</span>
                <span style="float:right">{{compressRatio}}%</span>
                <el-slider
                  v-model="compressRatio"
                  @change="changeCompressRatio"
                >
                </el-slider>
                <p style="font-size:12px;margin:10px;text-align:left;">选择压缩程度，数字越小，内存越小</p>
              </div>
              <div class="block" v-else>
                <span style="line-height:40px;">内存大小</span>
                <el-input v-model.number="compressSize" placeholder="期望内存" @keyup.enter.native="apply">
                  <i slot="suffix" style="line-height:40px;">KB</i>
                </el-input>
                <p style="font-size:12px;margin:10px;text-align:left;">实际内存与期望内存的误差在10%范围内</p>
              </div>
              <div class="divider" style="margin: 0 10px;"></div>
              <div class="button-group operation-button">
                <el-button class="cancel-custom" @click="handleCancel">重置</el-button>
              </div>
            </div>
          </div>
          <div class="image-main-container">
            <div class="image-editor">
              <div v-if="fileList.length" class="editor-wrap">
                <img
                  :src="currentImage.compressedUrl ? currentImage.compressedUrl : currentImage.url" 
                  style="width:100%;height:100%;object-fit:contain"
                />
              </div>
              <div class="upload-tips" v-else>
                <p>支持图片批量压缩</p>
                <el-upload
                  action="#"
                  accept=".jpg,.jpeg,.png,.bmp,.JPG,.JPEG,.BMP,.svg"
                  :file-list="fileList"
                  ref="dynamic"
                  :limit="IMAGE_LIMIT"
                  :on-change="handleChanged"
                  :on-exceed="(file, fileList) => handleExceed(file, fileList)"
                  :on-remove="handleRemove"
                  :auto-upload="false"
                  multiple
                >
                  <el-button size="large" type="default" class="upload-button">点击上传图片</el-button>
                </el-upload>
              </div>
              <div class="image-tips" v-if="currentImage.url">
                <p>
                  <span>图片的原始大小是{{this.$imageSize(currentImage.originalSize)}}, 压缩后的大小是 </span>
                  <span style="color:#4d90fe">{{this.$imageSize(currentImage.size)}}, 节省大约{{saveSpace}}</span>
                </p>
              </div>
            </div>
            <div class="image-list">
              <el-upload
                action="#"
                list-type="picture-card"
                accept=".jpg,.jpeg,.png,.bmp,.JPG,.JPEG,.BMP,.svg"
                :file-list="fileList"
                ref="dynamic"
                :limit="IMAGE_LIMIT"
                :show-file-list="true"
                :on-change="handleChanged"
                :on-exceed="(file, fileList) => handleExceed(file, fileList)"
                :on-remove="handleRemove"
                :auto-upload="false"
                multiple
              >
                <i class="el-icon-plus"></i>
                <div slot="file" 
                  slot-scope="{file}" 
                  :class="[file.isActive ? 'active' : '']"  
                  @click="selectCurrentImage(file)"
                >
                  <img
                    style="width:100%;height:100%;object-fit:contain"
                    :src="file.url"
                  />
                  <el-checkbox 
                    class="images-checkbox"
                    v-model="file.checked"
                    @click.stop.native="()=>{}"
                    @change="(value) => changeSelected(value, file)" 
                    :checked="file.checked"
                  >
                  </el-checkbox>
                  <div class="delete-images" @click.stop="handleRemove(file)">
                    <i class="el-icon-close"></i>
                  </div>
                </div>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="">
              </el-dialog>
            </div>
          </div>
          <!-- 右侧ad 展示以及分享 -->
          <div class="main-ad">
            <v-google-adsense></v-google-adsense>
            <div class="share">
              <v-share></v-share>
              <v-download :fileList="imageList"></v-download>
              <v-link-to :hideCompress="true" :fileList="imageList"></v-link-to>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const imageConversion = require("image-conversion");
export default {
  data () {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      fileList: [],

      // 当前的图片
      currentImage: {
        originalSize: null,
        size: null
      },
      // 压缩模式
      compressMode: 'ratio',
      // 输入框中的压缩比
      compressRatio: 60,
      // 实际作用的压缩比（应用：当未选中的时候，可以压缩，但是不记录住压缩的比例）
      customCompressRatio: 60,
      // 实际作用的压缩尺寸（同上）
      customCompressSize: null,
      // 压缩的内存大小
      compressSize: null,
      loading: false,
    }
  },
  computed: {
    limit () {
      return parseInt(this.IMAGE_LIMIT - this.fileList.length);
    },
    imageList () {
      return this.fileList.filter(item => item.checked == true);
    },
    saveSpace () {
      return this.$formatData((this.currentImage.originalSize - this.currentImage.size) * 100 / this.currentImage.originalSize, 2)  + '%'
    }
  },
  watch: {
    'imageList.length' () {
      if (!this.imageList.length) {
        this.compressRatio = 60;
        this.customCompressRatio = null;
        this.compressSize = null;
        this.customCompressSize = null;
      }
    }
  },
  methods: {
    handleCancel () {
      this.imageList.map(item => {
        item.checked = false;
        item.compressedUrl = '';
        item.base64Url = '';
        item.size = item.originalSize;

        this.setFileList(item);
        this.currentImage = this.fileList.find(item => item.uid === this.currentImage.uid);
      })
    },

    // 张数限制
    handleExceed(files, fileList) {
      // 如果总数大于9 或者是 当前选择的大于9都不能再上传。
      if (this.fileList.length > this.IMAGE_LIMIT || files.length > this.limit) {
        this.$message.error(`您选择的图片总数大于${this.IMAGE_LIMIT}张,您还可以选择${this.limit}张`)
      }
    },

    // 上传之前的钩子函数，限定上传图片的格式和大小
    checkImage (file) {
      var isImage = this.IMAGE_TYPE_LIST.indexOf(file.type) !== -1;
      var isLt10M = file.size / 1024 / 1024 < this.IMAGE_SIZE;

      if (!isImage) {
        this.$message.error('上传图片格式必须为jpg,jepg,png,jpg2,bmp,svg!');
        return false;
      }

      if (!isLt10M) {
        this.$message.error(`上传头像图片大小不能超过 ${this.IMAGE_SIZE}MB!`);
        return false;
      }
      return isImage && isLt10M;
    },

    //删除
    handleRemove(file) {
      if (this.fileList.length == 1) {
        this.currentImage = {};
      }
      // 删除当前所选的文件
      let removeFileIndex = this.fileList.findIndex(item => item.uid == file.uid);

      //删除图片之后，将isActive换成当前图片列表的后面一个，如果删除的是最后一张图片，就选中第一张
      var nextSelectImageIndex = removeFileIndex == (this.fileList.length - 1) ? 0 : removeFileIndex;
      this.fileList.splice(removeFileIndex, 1);

      // 如果删除的是当前选中的图片，则需要跳到下一张图片去
      // 如果不是只有一张图片，则选中下一个图片,当删除的是当前所选的图片
      if (this.fileList.length && this.currentImage.uid == file.uid) {
        this.selectCurrentImage(this.fileList[nextSelectImageIndex]);
      }
    },

    // 上传成功时的钩子函数，上传成功之后，默认选中所有图片
    handleChanged (file, fileList) {
      fileList.map((item,index) => {
        item.checked = true
        item.isActive = index ? false : true
        if (!item.originalSize) {
          item.originalSize = item.size;
        }
      })
      this.fileList = fileList;
      
      var readFilePromise = [];
      readFilePromise.push(this.init(file));

      Promise.all(readFilePromise)
        .then(() => {
          this.currentImage = Object.assign({}, this.fileList[0]);
          this.apply();
        })
      
    },

    changeCompressRatio () {
      this.apply()
    },

    // 当图片选中状态变化的时候触发的钩子函数
    changeSelected (value, file) {
      this.fileList.map(item => {
        item.isActive = false;
      })
      file.isActive = true;
      file.checked = value;

      this.currentImage = Object.assign({}, file); 

      if (!value) {
        //只要点了取消，都是复原,原图
        file.base64Url = '';
        file.compressedUrl = '';
        file.size = file.originalSize;

        this.currentImage = Object.assign({}, file);
        this.setFileList(file);
        return;
      } 
      // 当图片状态发生变化之后，如果是true,则选中的图片进行相同的操作，取消则恢复原图
      this.customCompressRatio = this.compressRatio;
      this.customCompressSize = this.compressSize;

      this.applyCompressWithTwoMode(this.currentImage, this.customCompressRatio, this.customCompressSize)
    },

    setFileList (file) {
      this.$set(this.fileList, this.fileList.findIndex(item => item.uid == file.uid), file);
    },

    // 给选中的图片添加边框样式
    selectCurrentImage (file) {
      this.fileList.map(item => {
        item.isActive = false;
      })
      file.isActive = true;
      this.currentImage = Object.assign({}, file)

      if (this.currentImage.checked) {
        this.compressRatio = this.customCompressRatio;
        this.compressSize = this.customCompressSize;
      } else {
        this.compressRatio = 60;
        file.compressedUrl = '';
        file.base64Url = '';
        file.size = file.originalSize;
      }

      this.setFileList(file);
      this.currentImage = Object.assign({}, file);
    },

    // 初始化file
    async init(fileObject) {
      // filetoImage 将file 转成image 对象
      const image = await this.filetoImage(fileObject.raw);

      // filetoDataURL file对象转为base64
      fileObject.base64Url = await imageConversion.filetoDataURL(fileObject.raw);
      fileObject.url = fileObject.base64Url;
      // img object 拿到width 和 height
      fileObject.width = image.width;
      fileObject.height = image.height;

      this.setFileList(fileObject);
    },

    // 使用百分比进行压缩：先选中一张图，点击压缩，再选中另外多张图
    async compressImageByRatio (file, quality) {
      const compress_file = await imageConversion.compress(file.raw, quality / 100);
      const compress_url_base64 = await imageConversion.filetoDataURL(compress_file);

      file.size = compress_file.size;
      
      file.base64Url = compress_url_base64;
      file.compressedUrl = compress_url_base64;
      this.setFileList(file);

      this.currentImage = this.fileList.find(item => item.uid === this.currentImage.uid);
    },

    // 使用内存大小进行压缩
    async compressImageBySize (file, quality, compressSize) {
      if (!compressSize) {
        return;
      }
      // compress_file 是一个blob 对象
      const compress_file = await imageConversion.compressAccurately(file.raw, {
        size: compressSize,
        accuracy: 0.99,
        width: file.width,
        height: file.height,
      });
      const compress_url_base64 = await imageConversion.filetoDataURL(compress_file);
      file.size = compress_file.size;
      file.base64Url = compress_url_base64;
      file.compressedUrl = compress_url_base64;
      this.setFileList(file);

      this.currentImage = this.fileList.find(item => item.uid === this.currentImage.uid)
    },

    async filetoImage(file) {
      const dataURL = await imageConversion.filetoDataURL(file);
      return await imageConversion.dataURLtoImage(dataURL);
    },

    applyCompressWithTwoMode (file, quality, compressSize) {
      // 使用 ratio 进行
      if (this.compressMode == 'ratio') {
        this.compressImageByRatio(file, quality);
      } else {
        this.compressImageBySize(file, null, compressSize);
      }
    },

    // 应用
    async apply () {
      // 当前图片未选中的情况下，可以压缩，但是不会被保存下来,且不会被应用到全部
      if (!this.currentImage.checked) {
        this.applyCompressWithTwoMode(this.currentImage, this.compressRatio, this.compressSize);
        return;
      }

      //在该图选中的情况下，进行压缩，则保存压缩之后的图像，
      this.customCompressRatio = this.compressRatio;
      this.customCompressSize = this.compressSize;

      this.imageList.forEach(item => {
        this.applyCompressWithTwoMode(item, this.customCompressRatio, this.customCompressSize)
      });
    },

    changeCompressMode () {
      if (this.compressMode == 'ratio') {
        this.compressSize = null;
        this.customCompressSize = null;
      } else {
        this.compressRatio = 60;
        this.customCompressRatio = null;
      }

      this.imageList.map(item => {
        item.compressedUrl = '';
        item.base64Url = '';
        item.size = item.originalSize;

        this.setFileList(item);
        this.currentImage = this.fileList.find(item => item.uid === this.currentImage.uid);
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.compress-image {
  margin: 30px 0px;
  margin-top: 0;

  .compress-options {
    margin: 10px 0;

    .compress-item {
      .item-label {
        font-size: 14px;
        margin-right: 5px;
      }
    }
  }
  .block {
    padding: 10px 0;
    overflow: hidden;

    span {
      font-size: 14px;
      color: #8492a6;
      line-height: 34px;
      display: inline-block;
    }
    .el-slider,
    .el-input {
      float: right;
      margin-right: 10px;
    }
    .el-input {
      width: 64%;
    }
    .el-slider {
      width: 52%;
    }
  }
}
.upload-tips {
  transform: translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// src/views/images/compress/index.vue